import { useRestaurantContext } from '@/contexts/RestaurantContext';

/**
 * Hook to access restaurant context
 * Provides: restaurants list, selected restaurant, and selection methods
 */
export const useRestaurants = () => {
  const context = useRestaurantContext();
  
  return {
    restaurants: context.restaurants,
    selectedRestaurant: context.selectedRestaurant,
    setSelectedRestaurant: context.setSelectedRestaurant,
    isLoading: context.isLoading,
    error: context.error,
    refresh: context.refresh,
    // Utility: check if user has multiple restaurants
    hasMultipleRestaurants: context.restaurants.length > 1,
    // Utility: get restaurant by id
    getRestaurantById: (id: string) => context.restaurants.find(r => r.id === id),
  };
};
